import axios from "axios";
import { chain, get } from "lodash";

import {
  API_GATEWAY_PROXY_CLIENT_API_ENDPOINT,
  API_CHANGE_API_STATUS_ENDPOINT,
  API_CREATE_API_ENDPOINT,
  API_CREATE_CATEGORY_ENDPOINT,
  API_GETUPLOADURL_ENDPOINT,
  API_GET_FEEDBACK_ENDPOINT,
  API_LIST_FEEDBACK_ENDPOINT,
  API_LIST_USERS_ENDPOINT,
  API_UPDATE_API_ENDPOINT,
  API_GET_CREDIT_CONFIG,
  API_UPDATE_CATEGORY_ENDPOINT,
  API_PUT_CREDIT_CONFIG,
  API_GET_CREDIT_FOR_MODAL,
  API_LIST_KEY_VALUE_PAIR,
  API_CREATE_KEY_VALUE_PAIR,
  API_UPDATE_KEY_VALUE_PAIR,
  API_CREATE_CERTIFICATE_ENDPOINT,
  API_UPDATE_CERTIFICATE_ENDPOINT,
  API_LIST_CERTIFICATE_ENDPOINT,
  API_GET_CERTIFICATE_ENDPOINT,
  API_DELETE_CERTIFICATE_ENDPOINT,
  API_POST_SETSTATUS,
  API_LIST_CUSTOMER_ENDPOINT,
  API_CREATE_CUSTOMER_ENDPOINT,
  API_UPDATE_CUSTOMER_ENDPOINT,
  API_GET_CUSTOMER_ENDPOINT,
  API_UPDATE_STATUS_CUSTOMER_ENDPOINT,
  API_GET_KEY_VALUE_PAIR,
  API_CREATE_SCHEDULED_JOB_ENDPOINT,
  API_UPDATE_SCHEDULED_JOB_ENDPOINT,
  API_UPDATE_SCHEDULED_JOB_STATUS_ENDPOINT,
  API_LIST_SCHEDULED_JOB_ENDPOINT,
  API_GET_SCHEDULED_JOB_ENDPOINT,
  API_CREATE_WORKFLOW_ENDPOINT,
  API_UPDATE_WORKFLOW_ENDPOINT,
  API_UPDATE_WORKFLOW_STATUS_ENDPOINT,
  API_LIST_WORKFLOW_ENDPOINT,
  API_GET_WORKFLOW_ENDPOINT,
  API_DELETE_USER_ENDPOINT,
  API_CHECK_API_ENDPOINT_AVAILABILITY_ENDPOINT,
  API_ATLAS_SETTINGS_LOG_RETENTION_POLICY_ENDPOINT,
  API_ATLAS_SETTINGS_ENDPOINT,
  API_GATEWAY_PROXY_WORKFLOW_EXECUTOR_API_ENDPOINT,
  API_LIST_API_GATEWAY_STAGE_ENDPOINT,
  API_GET_API_GATEWAY_STAGE_ENDPOINT,
  API_CREATE_API_GATEWAY_STAGE_ENDPOINT,
  API_UPDATE_API_GATEWAY_STAGE_ENDPOINT,
  API_LIST_API_GATEWAY_ENDPOINT,
  API_GET_API_GATEWAY_ENDPOINT,
  API_CREATE_API_GATEWAY_ENDPOINT,
  API_UPDATE_API_GATEWAY_ENDPOINT,
} from "../globals/constants";

export const listUsersApi = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_USERS_ENDPOINT,
    req
  );
};

export const getUrlForUploadApi = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_GETUPLOADURL_ENDPOINT,
    req
  );
};

export const createCategoryApi = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_CATEGORY_ENDPOINT,
    req
  );
};

export const updateCategoryApi = (id, req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_UPDATE_CATEGORY_ENDPOINT + "/" + id,
    req
  );
};

export const createApi = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_API_ENDPOINT,
    req
  );
};

export const updateApi = (id, req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_UPDATE_API_ENDPOINT + "/" + id,
    req
  );
};

export const changeAPIStatusApi = (id, req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CHANGE_API_STATUS_ENDPOINT + "/" + id,
    req
  );
};

export const lisFeedbackApi = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_FEEDBACK_ENDPOINT,
    req
  );
};

export const getFeedbackByIdApi = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_FEEDBACK_ENDPOINT + "/" + id
  );
};

export const adminTestAPI = (
  token,
  method,
  endpoint,
  body,
  apiId,
  headers = {},
  contentType
) => {
  return axios.create()({
    method: "POST",
    url:
      process.env.REACT_APP_GATEWAY_URL + API_GATEWAY_PROXY_CLIENT_API_ENDPOINT,
    data: body,
    headers: {
      Authorization: `Bearer ${token}`,
      "atlas-http-method": method,
      "atlas-http-url": endpoint,
      "atlas-http-api": apiId,
      "atlas-http-headers": chain(headers)
        .keys()
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(
              get(headers, [key], "")
            )}`
        )
        .join(",")
        .value(),
    },
  });
};

export const getCreditConfigAPI = () => {
  return axios.get(process.env.REACT_APP_ADMIN_URL + API_GET_CREDIT_CONFIG);
};

export const putCreditConfigAPI = (req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL + API_PUT_CREDIT_CONFIG,
    req
  );
};

export const addCreditsAPI = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL + API_GET_CREDIT_FOR_MODAL + "/" + id,
    req
  );
};

export const listKeyValuePair = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_KEY_VALUE_PAIR,
    req
  );
};

export const getKeyValuePair = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_KEY_VALUE_PAIR + "/" + id
  );
};

export const createKeyValuePair = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_KEY_VALUE_PAIR,
    req
  );
};

export const updateKeyValuePair = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL + API_UPDATE_KEY_VALUE_PAIR + "/" + id,
    req
  );
};

export const listApiGatewayStages = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_API_GATEWAY_STAGE_ENDPOINT,
    req
  );
};

export const getApiGatewayStage = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL +
      API_GET_API_GATEWAY_STAGE_ENDPOINT +
      "/" +
      id
  );
};

export const createApiGatewayStage = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_API_GATEWAY_STAGE_ENDPOINT,
    req
  );
};

export const updateApiGatewayStage = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_API_GATEWAY_STAGE_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const listApiGateway = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_API_GATEWAY_ENDPOINT,
    req
  );
};

export const getApiGateway = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_API_GATEWAY_ENDPOINT + "/" + id
  );
};

export const createApiGateway = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_API_GATEWAY_ENDPOINT,
    req
  );
};

export const updateApiGateway = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_API_GATEWAY_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const createCertificate = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_CERTIFICATE_ENDPOINT,
    req
  );
};

export const updateCertificate = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_CERTIFICATE_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const listCertificate = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_CERTIFICATE_ENDPOINT,
    req
  );
};

export const getCertificate = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_CERTIFICATE_ENDPOINT + "/" + id
  );
};

export const deleteCertificate = (id) => {
  return axios.delete(
    process.env.REACT_APP_ADMIN_URL + API_DELETE_CERTIFICATE_ENDPOINT + "/" + id
  );
};

export const setStatusAPI = (id, req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_POST_SETSTATUS + "/" + id,
    req
  );
};

export const listCustomerEndpoint = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_CUSTOMER_ENDPOINT,
    req
  );
};

export const getCustomerEndpoint = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_CUSTOMER_ENDPOINT + "/" + id
  );
};

export const createCustomerEndpoint = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_CUSTOMER_ENDPOINT,
    req
  );
};

export const updateCustomerEndpoint = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL + API_UPDATE_CUSTOMER_ENDPOINT + "/" + id,
    req
  );
};

export const updateCustomerEndpointStatus = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_STATUS_CUSTOMER_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const createScheduleJobAPI = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_SCHEDULED_JOB_ENDPOINT,
    req
  );
};

export const updateScheduleJobAPI = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_SCHEDULED_JOB_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const updateScheduleJobStatusAPI = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_SCHEDULED_JOB_STATUS_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const listScheduleJobEndpointAPI = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_SCHEDULED_JOB_ENDPOINT,
    req
  );
};

export const getScheduleJobEndpointAPI = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_SCHEDULED_JOB_ENDPOINT + "/" + id
  );
};

export const createWorkflowAPI = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_CREATE_WORKFLOW_ENDPOINT,
    req
  );
};

export const updateWorkflowAPI = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL + API_UPDATE_WORKFLOW_ENDPOINT + "/" + id,
    req
  );
};

export const updateWorkflowStatusAPI = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL +
      API_UPDATE_WORKFLOW_STATUS_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const listWorkflowEndpointAPI = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL + API_LIST_WORKFLOW_ENDPOINT,
    req
  );
};

export const getWorkflowEndpointAPI = (id) => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL + API_GET_WORKFLOW_ENDPOINT + "/" + id
  );
};

export const deleteUserEndpointAPI = (id) => {
  return axios.delete(
    process.env.REACT_APP_ADMIN_URL + API_DELETE_USER_ENDPOINT + "/" + id
  );
};

export const checkApiEndpointAvailability = (req) => {
  return axios.post(
    process.env.REACT_APP_ADMIN_URL +
      API_CHECK_API_ENDPOINT_AVAILABILITY_ENDPOINT,
    req
  );
};

export const getLogRetentionPolicySetting = () => {
  return axios.get(
    process.env.REACT_APP_ADMIN_URL +
      API_ATLAS_SETTINGS_LOG_RETENTION_POLICY_ENDPOINT
  );
};

export const updateAtlasSetting = (id, req) => {
  return axios.put(
    process.env.REACT_APP_ADMIN_URL + API_ATLAS_SETTINGS_ENDPOINT + "/" + id,
    req
  );
};

export const adminExecuteWorkflow = (req) => {
  return axios.post(
    process.env.REACT_APP_GATEWAY_URL +
      API_GATEWAY_PROXY_WORKFLOW_EXECUTOR_API_ENDPOINT,
    req
  );
};
